
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("8BgWe", function(module, exports) {
"use strict";
function $642eeafdd2f9e025$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $642eeafdd2f9e025$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $642eeafdd2f9e025$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;

var $642eeafdd2f9e025$var$_jquery = $642eeafdd2f9e025$var$_interopRequireDefault((parcelRequire("4kMWr")));

var $642eeafdd2f9e025$var$_swiper = $642eeafdd2f9e025$var$_interopRequireDefault((parcelRequire("htp1E")));

var $bTZx8 = parcelRequire("bTZx8");

var $642eeafdd2f9e025$var$bs = $642eeafdd2f9e025$var$_interopRequireWildcard((parcelRequire("5flOQ")));

var $ehtzh = parcelRequire("ehtzh");
function $642eeafdd2f9e025$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($642eeafdd2f9e025$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $642eeafdd2f9e025$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $642eeafdd2f9e025$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $642eeafdd2f9e025$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $642eeafdd2f9e025$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $642eeafdd2f9e025$var$vgOptions = {};
var $642eeafdd2f9e025$var$allSlides = [];
var $642eeafdd2f9e025$var$allKeywords = [];
var $642eeafdd2f9e025$var$base = window.location.href.split("?")[0];
var $642eeafdd2f9e025$var$baseDataLayer = {
    event: "gtmEvent",
    event_name: "video_interaction",
    event_category: "HTML5 Video"
};
// ###################################################################################################
// # FUNCTIONS #######################################################################################
// ###################################################################################################
var $642eeafdd2f9e025$var$hideEmptyCategories = function hideEmptyCategories() {
    document.querySelectorAll(".vg_category").forEach(function(category) {
        category.classList.remove("hide-category");
        var height = category.querySelector(".vg_slider").offsetHeight;
        if (height === 0) category.classList.add("hide-category");
    });
};
var $642eeafdd2f9e025$var$checkEmptyCategories = function checkEmptyCategories() {
    var visibleCategories = 0;
    (0, $642eeafdd2f9e025$var$_jquery["default"])(".vg_category").each(function() {
        if ((0, $642eeafdd2f9e025$var$_jquery["default"])(this).is(":visible")) visibleCategories += 1;
    });
    if (visibleCategories === 0) (0, $642eeafdd2f9e025$var$_jquery["default"])(".empty-state").show();
    else (0, $642eeafdd2f9e025$var$_jquery["default"])(".empty-state").hide();
};
var $642eeafdd2f9e025$var$getLowerCaseString = function getLowerCaseString(data) {
    var string = data.toString().toLowerCase();
    string = string.toLowerCase();
    return string;
};
var $642eeafdd2f9e025$var$updateButtonPositions = function updateButtonPositions() {
    var element = document.querySelector(".ref-container");
    if (element) {
        var rect = element.getBoundingClientRect();
        var left = rect.left + window.scrollX;
        var right = rect.right + window.scrollX;
        $642eeafdd2f9e025$var$vgOptions.left = left;
        $642eeafdd2f9e025$var$vgOptions.right = right;
        // vgOptions.before = left - 30;
        // vgOptions.after = left - 30;
        // console.log("left", left);
        if (left - 30 > 80) {
            $642eeafdd2f9e025$var$vgOptions.before = left - 30;
            $642eeafdd2f9e025$var$vgOptions.after = left - 30;
        } else {
            $642eeafdd2f9e025$var$vgOptions.before = 65;
            $642eeafdd2f9e025$var$vgOptions.after = 65;
        }
        var prevPos = left - 30 - 60;
        var nextPos = right + 30;
        if (window.innerWidth < 1350) {
            prevPos = 5;
            nextPos = window.innerWidth - 5 - 60;
        }
        if (window.innerWidth < 992) {
            //   prevPos = 5;
            //   nextPos = window.innerWidth - 5 - 60;
            $642eeafdd2f9e025$var$vgOptions.before = 0;
            $642eeafdd2f9e025$var$vgOptions.after = 0;
        }
        if (window.innerWidth < 768) // prevPos = 5;
        nextPos = window.innerWidth - 5 - 40;
        (0, $642eeafdd2f9e025$var$_jquery["default"])(".vg_category .swiper-button-prev").css("left", "".concat(prevPos, "px"));
        (0, $642eeafdd2f9e025$var$_jquery["default"])(".vg_category .swiper-button-next").css("left", "".concat(nextPos, "px"));
        (0, $642eeafdd2f9e025$var$_jquery["default"])(window).trigger("updateSlider");
    }
    return 0;
};
var $642eeafdd2f9e025$var$checkSlideVisibility = function checkSlideVisibility(swiper) {
    var slides = swiper.slides;
    var count = 0;
    var inViewport = 0;
    slides.forEach(function(slide) {
        var $slide = (0, $642eeafdd2f9e025$var$_jquery["default"])(slide);
        var slideRect = slide.getBoundingClientRect();
        var viewLeft = $642eeafdd2f9e025$var$vgOptions.left - 31;
        var viewRight = $642eeafdd2f9e025$var$vgOptions.right + 31;
        if (window.innerWidth < 1350) {
            viewLeft = 0;
            viewRight = window.innerWidth + 1;
        }
        if (slideRect.left >= viewLeft && slideRect.right <= viewRight + 20) {
            inViewport = inViewport + 1;
            $slide.addClass("in-viewport");
        } else $slide.removeClass("in-viewport");
        count++;
    });
    return count === inViewport;
};
var $642eeafdd2f9e025$var$filterCategories = function filterCategories() {
    var $this = (0, $642eeafdd2f9e025$var$_jquery["default"])(".btn.category-select.active");
    if ($this.length === 0) (0, $642eeafdd2f9e025$var$_jquery["default"])(".vg_category").removeClass("hide");
    else {
        var data = $this.data();
        (0, $642eeafdd2f9e025$var$_jquery["default"])(".vg_category").each(function() {
            var $category = (0, $642eeafdd2f9e025$var$_jquery["default"])(this);
            var cData = $category.data();
            if (cData.uid === data.uid) $category.removeClass("hide");
            else $category.addClass("hide");
        });
    }
    $642eeafdd2f9e025$var$hideEmptyCategories();
    $642eeafdd2f9e025$var$checkEmptyCategories();
};
var $642eeafdd2f9e025$var$filterVideos = function filterVideos(keywords, country) {
    var visibleSlides = 0;
    // console.log("filterVideos", keywords, country);
    $642eeafdd2f9e025$var$allSlides.forEach(function(slide) {
        var showCountry = false;
        var showKeywords = false;
        if (!isNaN(country)) // console.log("slide.countries", slide.countries.includes(country));
        {
            if (slide.countries.includes(country)) showCountry = true;
        } else showCountry = true;
        if (keywords.length > 0) {
            // console.log("slide.keywords", slide.keywords.includes(keywords));
            if (slide.keywords.includes(keywords)) showKeywords = true;
            // console.log("slide.title", slide.title.includes(keywords));
            if (slide.title.includes(keywords)) showKeywords = true;
        } else showKeywords = true;
        if (showCountry && showKeywords) {
            if (slide.visible) (0, $642eeafdd2f9e025$var$_jquery["default"])("#".concat(slide.id)).remove();
            (0, $642eeafdd2f9e025$var$_jquery["default"])("#".concat(slide.parent, " .swiper-wrapper")).append(slide.html);
            slide.visible = true;
            visibleSlides++;
        } else {
            if (slide.visible) (0, $642eeafdd2f9e025$var$_jquery["default"])("#".concat(slide.id)).remove();
            slide.visible = false;
        }
    });
    visibleSlides > 0 ? (0, $642eeafdd2f9e025$var$_jquery["default"])(".empty-state").hide() : (0, $642eeafdd2f9e025$var$_jquery["default"])(".empty-state").show();
    (0, $642eeafdd2f9e025$var$_jquery["default"])(window).trigger("resetSlider");
    $642eeafdd2f9e025$var$filterCategories();
    $642eeafdd2f9e025$var$hideEmptyCategories();
    $642eeafdd2f9e025$var$checkEmptyCategories();
};
var $642eeafdd2f9e025$var$resetVideos = function resetVideos() {
    $642eeafdd2f9e025$var$allSlides.forEach(function(slide) {
        if (slide.visible) (0, $642eeafdd2f9e025$var$_jquery["default"])("#".concat(slide.id)).remove();
        (0, $642eeafdd2f9e025$var$_jquery["default"])("#".concat(slide.parent, " .swiper-wrapper")).append(slide.html);
        slide.visible = true;
    });
    (0, $642eeafdd2f9e025$var$_jquery["default"])("#vg_country").val("");
    (0, $642eeafdd2f9e025$var$_jquery["default"])("#vg_keywords").val("");
    (0, $642eeafdd2f9e025$var$_jquery["default"])(window).trigger("resetSlider");
    (0, $642eeafdd2f9e025$var$_jquery["default"])(".empty-state").hide();
    $642eeafdd2f9e025$var$filterCategories();
    $642eeafdd2f9e025$var$hideEmptyCategories();
    $642eeafdd2f9e025$var$checkEmptyCategories();
};
var $642eeafdd2f9e025$var$autocomplete = function autocomplete(inp, arr) {
    var currentFocus;
    var addActive = function addActive(x) {
        if (!x) return false;
        removeActive(x);
        if (currentFocus >= x.length) currentFocus = 0;
        if (currentFocus < 0) currentFocus = x.length - 1;
        x[currentFocus].classList.add("autocomplete-active");
    };
    var removeActive = function removeActive(x) {
        for(var i = 0; i < x.length; i++)x[i].classList.remove("autocomplete-active");
    };
    var closeAllLists = function closeAllLists(elmnt) {
        var x = document.getElementsByClassName("autocomplete-items");
        for(var i = 0; i < x.length; i++)if (elmnt != x[i] && elmnt != inp) x[i].parentNode.removeChild(x[i]);
    };
    inp.addEventListener("input", function(e) {
        var a;
        var b;
        var i = 0;
        var val = this.value;
        closeAllLists();
        if (!val) return false;
        currentFocus = -1;
        a = document.createElement("DIV");
        a.setAttribute("id", this.id + "autocomplete-list");
        a.setAttribute("class", "autocomplete-items");
        this.parentNode.appendChild(a);
        for(i = 0; i < arr.length; i++)if (arr[i].toUpperCase().includes(val.toUpperCase())) {
            b = document.createElement("DIV");
            var highlighted = arr[i].replace(new RegExp(val, "gi"), function(match) {
                return "<strong>".concat(match, "</strong>");
            });
            b.innerHTML = highlighted;
            b.innerHTML += "<input type='hidden' value='" + arr[i] + "'>";
            b.addEventListener("click", function(e) {
                inp.value = this.getElementsByTagName("input")[0].value;
                closeAllLists();
            });
            a.appendChild(b);
        }
    });
    inp.addEventListener("keydown", function(e) {
        var x = document.getElementById(this.id + "autocomplete-list");
        if (x) x = x.getElementsByTagName("div");
        if (e.keyCode == 40) {
            currentFocus++;
            addActive(x);
        } else if (e.keyCode == 38) {
            currentFocus--;
            addActive(x);
        } else if (e.keyCode == 13) {
            e.preventDefault();
            if (currentFocus > -1) {
                if (x) x[currentFocus].click();
            }
        }
    });
    document.addEventListener("click", function(e) {
        return closeAllLists(e.target);
    });
};
// ###################################################################################################
// # INIT ############################################################################################
// ###################################################################################################
var $642eeafdd2f9e025$var$init = module.exports.init = function init() {
    // delete all $("#vg_modal") except one
    var foundModal = false;
    (0, $642eeafdd2f9e025$var$_jquery["default"])(".vg_modal").each(function(index) {
        if (foundModal) (0, $642eeafdd2f9e025$var$_jquery["default"])(this).remove();
        if ((0, $642eeafdd2f9e025$var$_jquery["default"])(this).attr("id") === "vg_modal") foundModal = true;
    });
    var $modal = (0, $642eeafdd2f9e025$var$_jquery["default"])("#vg_modal");
    var $modalBody = $modal.find(".modal-body");
    var $modalContent = $modal.find(".modal-content");
    var $modalClose = $modal.find(".modal-close");
    $modalClose.on("click", function(e) {
        $modal.modal("hide");
        $modalBody.html("");
    });
    (0, $642eeafdd2f9e025$var$_jquery["default"])(window).on("resize", function() {
        return $642eeafdd2f9e025$var$updateButtonPositions();
    });
    // ----------------------------------------------
    // init sliders
    // ----------------------------------------------
    (0, $642eeafdd2f9e025$var$_jquery["default"])(".vg_category").each(function(e) {
        var $this = (0, $642eeafdd2f9e025$var$_jquery["default"])(this);
        var cID = $this.attr("id");
        var data = $this.data();
        var id = $this.find(".vg_slider").attr("id");
        var $wrapper = $this.find(".swiper-wrapper");
        $wrapper.find(".swiper-slide").each(function() {
            var $slide = (0, $642eeafdd2f9e025$var$_jquery["default"])(this);
            var $video = $slide.find(".vg_video");
            var sID = $slide.attr("id");
            var obj = {
                id: sID,
                parent: cID,
                visible: true,
                keywords: $642eeafdd2f9e025$var$getLowerCaseString($video.data("keywords")),
                title: $642eeafdd2f9e025$var$getLowerCaseString($video.find(".vg_title").text()),
                countries: $video.data("countries").toString(),
                html: $slide[0].outerHTML
            };
            var keywordsArray = $video.data("keywords").split(",");
            keywordsArray.forEach(function(keyword) {
                keyword = keyword.trim();
                if (!$642eeafdd2f9e025$var$allKeywords.includes(keyword)) $642eeafdd2f9e025$var$allKeywords.push(keyword);
            });
            $642eeafdd2f9e025$var$allSlides.push(obj);
        });
        // console.log("allSlides", allSlides);
        var slideCount = $wrapper.find(".swiper-slide").length;
        $wrapper.css("width", "".concat(slideCount * 400, "px"));
        (0, $642eeafdd2f9e025$var$_jquery["default"])('.btn.category-select[data-uid="'.concat(data.uid, '"]')).removeAttr("disabled");
        var swiper = new $642eeafdd2f9e025$var$_swiper["default"]("#".concat(id), {
            modules: [
                $bTZx8.Navigation,
                $bTZx8.Keyboard,
                $bTZx8.A11y
            ],
            slidesPerView: "auto",
            slidesOffsetBefore: 15,
            slidesOffsetAfter: 15,
            rewind: true,
            watchOverflow: false,
            navigation: {
                nextEl: "#".concat(cID, " .swiper-button-next"),
                prevEl: "#".concat(cID, " .swiper-button-prev")
            },
            keyboard: {
                enabled: true
            },
            a11y: {
                enabled: true
            },
            fadeEffect: {
                crossFade: true
            },
            on: {
                afterInit: function afterInit() {
                    (0, $642eeafdd2f9e025$var$_jquery["default"])("#".concat(cID)).addClass("slider-init");
                    (0, $642eeafdd2f9e025$var$_jquery["default"])("#".concat(cID)).show();
                },
                slideChangeTransitionEnd: function slideChangeTransitionEnd(swiper) {
                    var isLocked = $642eeafdd2f9e025$var$checkSlideVisibility(swiper);
                    if (isLocked) swiper.disable();
                    else {
                        swiper.enable();
                        (0, $642eeafdd2f9e025$var$_jquery["default"])("#".concat(cID, " .swiper-button-next")).removeClass("swiper-button-lock");
                        (0, $642eeafdd2f9e025$var$_jquery["default"])("#".concat(cID, " .swiper-button-prev")).removeClass("swiper-button-lock");
                    }
                },
                update: function update(swiper) {
                    var isLocked = $642eeafdd2f9e025$var$checkSlideVisibility(swiper);
                    if (isLocked) swiper.disable();
                    else {
                        swiper.enable();
                        (0, $642eeafdd2f9e025$var$_jquery["default"])("#".concat(cID, " .swiper-button-next")).removeClass("swiper-button-lock");
                        (0, $642eeafdd2f9e025$var$_jquery["default"])("#".concat(cID, " .swiper-button-prev")).removeClass("swiper-button-lock");
                    }
                }
            }
        });
        (0, $642eeafdd2f9e025$var$_jquery["default"])(window).on("updateSlider", function() {
            swiper.params.slidesOffsetBefore = $642eeafdd2f9e025$var$vgOptions.before;
            swiper.params.slidesOffsetAfter = $642eeafdd2f9e025$var$vgOptions.after;
            setTimeout(function() {
                return swiper.update();
            }, 300);
        });
        (0, $642eeafdd2f9e025$var$_jquery["default"])(window).on("resetSlider", function() {
            swiper.params.slidesOffsetBefore = $642eeafdd2f9e025$var$vgOptions.before;
            swiper.params.slidesOffsetAfter = $642eeafdd2f9e025$var$vgOptions.after;
            swiper.slideTo(0, 0);
            setTimeout(function() {
                return swiper.update();
            }, 300);
        });
    });
    $642eeafdd2f9e025$var$allKeywords.splice($642eeafdd2f9e025$var$allKeywords.indexOf(""), 1);
    $642eeafdd2f9e025$var$allKeywords.sort();
    // console.log("allKeywords", allKeywords);
    $642eeafdd2f9e025$var$updateButtonPositions();
    $642eeafdd2f9e025$var$autocomplete(document.getElementById("vg_keywords"), $642eeafdd2f9e025$var$allKeywords);
    // ----------------------------------------------
    // search on category select
    // ----------------------------------------------
    (0, $642eeafdd2f9e025$var$_jquery["default"])("#vg_country").on("change", function(e) {
        e.preventDefault();
        var formData = (0, $642eeafdd2f9e025$var$_jquery["default"])(this).closest("form").serializeArray();
        var country = parseInt(formData[0].value);
        var keywords = $642eeafdd2f9e025$var$getLowerCaseString(formData[1].value);
        if (isNaN(country) && keywords.length === 0) $642eeafdd2f9e025$var$resetVideos();
        else $642eeafdd2f9e025$var$filterVideos(keywords, country);
    });
    // ----------------------------------------------
    // search on form submit
    // ----------------------------------------------
    (0, $642eeafdd2f9e025$var$_jquery["default"])("#vg_submit").closest("form").on("submit", function(e) {
        e.preventDefault();
        var formData = (0, $642eeafdd2f9e025$var$_jquery["default"])(this).serializeArray();
        var country = parseInt(formData[0].value);
        var keywords = $642eeafdd2f9e025$var$getLowerCaseString(formData[1].value);
        if (isNaN(country) && keywords.length === 0) $642eeafdd2f9e025$var$resetVideos();
        else $642eeafdd2f9e025$var$filterVideos(keywords, country);
    });
    // ----------------------------------------------
    // search on form reset
    // ----------------------------------------------
    (0, $642eeafdd2f9e025$var$_jquery["default"])("#vg_reset").closest("form").on("reset", function(e) {
        e.preventDefault();
        $642eeafdd2f9e025$var$resetVideos();
    });
    // ----------------------------------------------
    // filter by category
    // ----------------------------------------------
    (0, $642eeafdd2f9e025$var$_jquery["default"])(".btn.category-select").on("click", function(e) {
        var $this = (0, $642eeafdd2f9e025$var$_jquery["default"])(this);
        if ($this.hasClass("active")) $this.removeClass("active");
        else {
            (0, $642eeafdd2f9e025$var$_jquery["default"])(".btn.category-select.active").removeClass("active");
            $this.addClass("active");
        }
        $642eeafdd2f9e025$var$filterCategories();
    });
    // ----------------------------------------------
    // modal handling
    // ----------------------------------------------
    (0, $642eeafdd2f9e025$var$_jquery["default"])(".vg_button.play").on("click", function(e) {
        var uid = (0, $642eeafdd2f9e025$var$_jquery["default"])(this).data("uid");
        var url = "".concat($642eeafdd2f9e025$var$base, "?type=1710230152&video=").concat(uid);
        $modalContent.addClass("loading");
        $modal.modal("show");
        fetch(url, {
            method: "GET"
        }).then(function(response) {
            return response.json();
        }).then(function(data) {
            $modalBody.html(data.html);
            var target = $modal.find(".video-play-button").data("target");
            (0, $ehtzh.video)(target);
            $modal.on("hidden.bs.modal", function(e) {
                return $modalBody.html("");
            });
            $modalContent.removeClass("loading");
        // $modal.find(".video-play-button").click();
        })["catch"](function(error) {
            return console.error("Error:", error);
        });
    });
};

});
parcelRegister("ehtzh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.video = void 0;

var $a65996d470b560bc$var$_plyr = $a65996d470b560bc$var$_interopRequireDefault((parcelRequire("hT1t7")));

var $cGTs6 = parcelRequire("cGTs6");
function $a65996d470b560bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $a65996d470b560bc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a65996d470b560bc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a65996d470b560bc$var$ownKeys(Object(t), !0).forEach(function(r) {
            $a65996d470b560bc$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a65996d470b560bc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a65996d470b560bc$var$_defineProperty(e, r, t) {
    return (r = $a65996d470b560bc$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $a65996d470b560bc$var$_toPropertyKey(t) {
    var i = $a65996d470b560bc$var$_toPrimitive(t, "string");
    return "symbol" == $a65996d470b560bc$var$_typeof(i) ? i : i + "";
}
function $a65996d470b560bc$var$_toPrimitive(t, r) {
    if ("object" != $a65996d470b560bc$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $a65996d470b560bc$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $a65996d470b560bc$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a65996d470b560bc$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a65996d470b560bc$var$_typeof(o);
}
// const base = window.location.href.split("?")[0];
var $a65996d470b560bc$var$vData = {
    status: {},
    youtube: {
        id: "BJz7qNsdj-7",
        consent: false
    },
    vimeo: {
        id: "",
        consent: false
    },
    plyrOptions: {
        iconUrl: "/typo3conf/ext/as_template/Resources/Public/Vendor/plyr/plyr.svg",
        blankVideo: "/typo3conf/ext/as_template/Resources/Public/Vendor/plyr/blank.mp4",
        youtube: {
            noCookie: true
        },
        controls: [
            "play-large",
            "play",
            "progress",
            "current-time",
            "mute",
            "volume",
            "captions",
            "settings",
            "airplay",
            "fullscreen"
        ]
    },
    baseDataLayer: {
        event: "gtmEvent",
        event_name: "video_interaction",
        event_category: "HTML5 Video"
    }
};
var $a65996d470b560bc$var$checkConsent = function checkConsent() {
    if ((0, $cGTs6.checkUcInit)()) {
        if ((0, $cGTs6.getUcService)("BJz7qNsdj-7")) {
            document.body.classList.remove("noYoutube");
            $a65996d470b560bc$var$vData.youtube.consent = true;
        } else {
            document.body.classList.add("noYoutube");
            $a65996d470b560bc$var$vData.youtube.consent = false;
        }
    }
};
var $a65996d470b560bc$var$getVideoName = function getVideoName(plyr) {
    var videoName = plyr.elements.original.dataset.plyrEmbedId;
    if (plyr.provider === "html5") {
        var name = plyr.elements.original.currentSrc;
        if (name.includes("mediapool")) {
            var a1 = name.split("mediapool");
            videoName = a1[1];
        } else if (name.includes("fileadmin")) {
            var a2 = name.split("fileadmin");
            videoName = a2[1];
        }
    }
    return videoName;
};
var $a65996d470b560bc$var$timeupdate = function timeupdate(e, id) {
    var currentTime = e.detail.plyr.media.currentTime;
    var duration = e.detail.plyr.media.duration;
    var videoName = $a65996d470b560bc$var$getVideoName(e.detail.plyr);
    $a65996d470b560bc$var$vData.status[id].current = Math.round(currentTime);
    var pct = Math.floor(100 * currentTime / duration);
    // console.log(vData.status[id]._progress_markers);
    for(var j in $a65996d470b560bc$var$vData.status[id]._progress_markers)if (pct >= parseInt(j) && parseInt(j) >= parseInt($a65996d470b560bc$var$vData.status[id].greatest_marker)) $a65996d470b560bc$var$vData.status[id].greatest_marker = j;
    if ((typeof dataLayer === "undefined" ? "undefined" : $a65996d470b560bc$var$_typeof(dataLayer)) !== undefined) {
        if ($a65996d470b560bc$var$vData.status[id].greatest_marker && !$a65996d470b560bc$var$vData.status[id]._progress_markers[$a65996d470b560bc$var$vData.status[id].greatest_marker]) {
            $a65996d470b560bc$var$vData.status[id]._progress_markers[$a65996d470b560bc$var$vData.status[id].greatest_marker] = true;
            dataLayer.push($a65996d470b560bc$var$_objectSpread($a65996d470b560bc$var$_objectSpread({}, $a65996d470b560bc$var$vData.baseDataLayer), {}, {
                event_action: "Played video",
                video_name: videoName,
                video_progress: $a65996d470b560bc$var$vData.status[id].greatest_marker / 100
            }));
        }
    }
// console.log("timeupdate", dataLayer);
};
var $a65996d470b560bc$var$playUpdate = function playUpdate(e, id) {
    var videoName = $a65996d470b560bc$var$getVideoName(e.detail.plyr);
    dataLayer.push($a65996d470b560bc$var$_objectSpread($a65996d470b560bc$var$_objectSpread({}, $a65996d470b560bc$var$vData.baseDataLayer), {}, {
        event_action: "Play video",
        video_name: videoName
    }));
// console.log("playUpdate", dataLayer);
};
var $a65996d470b560bc$var$pauseUpdate = function pauseUpdate(e, id) {
    var videoName = $a65996d470b560bc$var$getVideoName(e.detail.plyr);
    dataLayer.push($a65996d470b560bc$var$_objectSpread($a65996d470b560bc$var$_objectSpread({}, $a65996d470b560bc$var$vData.baseDataLayer), {}, {
        event_action: "Pause video",
        video_name: videoName
    }));
// console.log("pauseUpdate", dataLayer);
};
var $a65996d470b560bc$var$seekedUpdate = function seekedUpdate(e, cTime) {
    var videoName = $a65996d470b560bc$var$getVideoName(e.detail.plyr);
    dataLayer.push($a65996d470b560bc$var$_objectSpread($a65996d470b560bc$var$_objectSpread({}, $a65996d470b560bc$var$vData.baseDataLayer), {}, {
        event_action: "Seek video",
        video_seek: cTime,
        video_name: videoName
    }));
// console.log("seekedUpdate", dataLayer);
};
var $a65996d470b560bc$var$video = module.exports.video = function video(id) {
    var player = null;
    var local = false;
    var plyr = true;
    var videoTagId = "".concat(id, "_html5_api");
    var videoEl = document.querySelector("#".concat(id));
    var videoBox = videoEl.closest(".video-box");
    var videoBtn = videoBox.querySelector(".video-play-button");
    var ucNotice = videoBox.querySelector(".uc-notice");
    var ucNoticeBtn = videoBox.querySelector(".uc-notice .btn.primary");
    var init = function init() {
        player = new $a65996d470b560bc$var$_plyr["default"]("#".concat(id), $a65996d470b560bc$var$vData.plyrOptions);
        $a65996d470b560bc$var$vData.status[videoTagId] = {};
        $a65996d470b560bc$var$vData.status[videoTagId].greatest_marker = 0;
        $a65996d470b560bc$var$vData.status[videoTagId]._progress_markers = {};
        // part progress in 25% steps
        for(var j = 0; j <= 100; j++){
            $a65996d470b560bc$var$vData.status[videoTagId].progress_point = 25 * Math.floor(j / 25);
            $a65996d470b560bc$var$vData.status[videoTagId]._progress_markers[$a65996d470b560bc$var$vData.status[videoTagId].progress_point] = false;
        }
        $a65996d470b560bc$var$vData.status[videoTagId].current = 0;
        player.on("ready", function(e) {
            player.on("timeupdate", function(e) {
                return $a65996d470b560bc$var$timeupdate(e, videoTagId);
            });
            player.on("playing", function(e) {
                return videoBox.classList.add("playing");
            });
            player.on("seeked", function(e) {
                return $a65996d470b560bc$var$seekedUpdate(e, player.currentTime);
            });
            player.on("ended", function() {
                return videoBox.classList.remove("playing");
            });
            player.on("play", function(e) {
                $a65996d470b560bc$var$playUpdate(e, videoTagId);
                videoBox.classList.add("playing");
            });
            player.on("pause", function(e) {
                $a65996d470b560bc$var$pauseUpdate(e, videoTagId);
                if (player.seeking === false) videoBox.classList.remove("playing");
            });
            player.play();
        });
        videoBox.classList.add("init");
    };
    var play = function play() {
        return player.play();
    };
    // ============================================================
    // ============================================================
    $a65996d470b560bc$var$checkConsent();
    if (videoEl.classList.contains("local")) local = true;
    if (videoEl.classList.contains("js-player")) plyr = false;
    if (local) player ? play() : init();
    else if (!$a65996d470b560bc$var$vData.youtube.consent && !$a65996d470b560bc$var$vData.vimeo.consent) ucNotice.classList.add("active");
    else {
        ucNotice.classList.remove("active");
        player ? play() : init();
    }
    if (ucNoticeBtn) ucNoticeBtn.addEventListener("click", function() {
        videoBtn.classList.add("loading");
        (0, $cGTs6.acceptUcService)("BJz7qNsdj-7");
        $a65996d470b560bc$var$checkConsent();
        setTimeout(function() {
            $a65996d470b560bc$var$checkConsent();
            if ($a65996d470b560bc$var$vData.youtube.consent || $a65996d470b560bc$var$vData.vimeo.consent) {
                player ? play() : init();
                ucNotice.classList.remove("active");
            }
        }, 500);
    });
    $(document).on("asuc-updated", function() {
        return $a65996d470b560bc$var$checkConsent();
    });
    videoBtn.classList.add("loading");
    videoBtn.addEventListener("click", function() {
        return player ? play() : init();
    });
};

});


parcelRegister("7bv9Y", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $53b1bb303d082687$export$581ff339ea0ba762; });

var $cgqFP = parcelRequire("cgqFP");
function $53b1bb303d082687$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $cgqFP._define_property)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("cgqFP", function(module, exports) {

$parcel$export(module.exports, "_define_property", function () { return $8edbab78a07e92a4$export$1e71eb4bef00f6b0; });
function $8edbab78a07e92a4$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("evINV", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a906b7200f9116bb$export$4fa2f4023c9cbda5; });
function $a906b7200f9116bb$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a906b7200f9116bb$export$4fa2f4023c9cbda5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $a906b7200f9116bb$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});


//# sourceMappingURL=asVideoGalleryGallery.module.b4e4cecf.js.map
